/*
 * @Author: cc
 * @LastEditTime: 2021-07-23 10:05:11
 */
export async function fetchPost(url: string, data: any) {
  const result = await fetch(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })
  return result.json()
}

export async function fetchGet(url: string, data: any) {
  const result = await fetch(url, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json"
    },
  })
  return result.json()
}